import {inject} from '@angular/core';
import {HttpEvent, HttpEventType, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {map, Observable} from 'rxjs';
import {TokenCacheService} from "./token-cache.service";
import {environment} from "../../../../environments/environment";

export const TokenInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const tokenCacheService = inject(TokenCacheService);

    if (req.url.startsWith(environment.api) && !!tokenCacheService.token) {
        req = req.clone({
            headers: req.headers.set('Authorization', `${tokenCacheService.token.type} ${tokenCacheService.token.token}`)
        });
    }

    return next(req);
}

export const DateInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    return next(req.clone({
        body: formatDates(req.body),
    })).pipe(map(event => {
        if (event.type === HttpEventType.Response) {
            if (!!event.body) {
                event = event.clone({
                    body: parseDates(event.body)
                })
            }
        }

        return event;
    }));
}

const parseDates = (obj: any): any => {
    if (!obj) {
        return obj;
    } else if (typeof obj === 'object') {
        for (const key of Object.keys(obj)) {
            obj[key] = parseDates(obj[key]);
        }

        return obj;
    } else if (Array.isArray(obj)) {
        return obj.map((it: any) => parseDates(it));
    } else if (typeof obj === 'string') {
        if (obj.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d+Z$/)) {
            return new Date(obj);
        } else if (obj.match(/^\d{4}-\d{2}-\d{2}$/)) {
            // Data-only (sem hora): construir Date no fuso LOCAL, não em UTC.
            // `new Date("2025-01-01")` seria meia-noite UTC → exibido com o DatePipe local
            // (America/Sao_Paulo, UTC-3) volta 1 dia (31/12/2024). Espelha o ramo DD/MM/YYYY abaixo.
            const parts = obj.split('-');
            return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else if (obj.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
            const parts = obj.split('/');
            return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
        } else {
            return obj;
        }
    } else {
        return obj;
    }
}


const formatDates = (obj: any): any => {
    if (!obj) {
        return obj;
    } else if (obj instanceof Date) {
        return `${obj.getFullYear().toString().padStart(4, '0')}-${(obj.getMonth() + 1).toString().padStart(2, '0')}-${obj.getDate().toString().padStart(2, '0')}`;
    } else if (Array.isArray(obj)) {
        return obj.map((it: any) => formatDates(it));
    } else if (typeof obj === 'object') {
        for (const key of Object.keys(obj)) {
            obj[key] = formatDates(obj[key]);
        }

        return obj;
    } else {
        return obj;
    }
}
